import { createFileRoute } from "@tanstack/react-router";
import SignUpForm from "@/ui/components/auth/sign-up";

export const Route = createFileRoute("/_auth/sign-up")({
  component: SignUpForm,
});
